import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PaymentErrorScreenComponent } from '@app/modules/setting/dialogs/payment-error-screen/payment-error-screen.component';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: 'my-auth-token',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class UserPermissionService {
  constructor(private readonly httpService: AmplifyHttpClient, private dialog: MatDialog) {}

  getConnections(type = 'user', params) {
    return this.httpService.post<any>(`api/permission/` + type + `-connections`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserHistory(isLoader = true) {
    return this.httpService.get<any>(`api/payment/invoice-history`, null, isLoader ? loaderTypes.mainAnimation : loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateSubscriptionFamilyLicense(data) {
    return this.httpService.post<any>(`api/payment/update-subscription-family-license`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  removeSubscriptionWithFamilyLicense(data) {
    return this.httpService.post<any>(`api/payment/remove-subscription-family-license`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateSubscriptionProfessionalLicense(data) {
    return this.httpService.post<any>(`api/payment/update-subscription-professional-license`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  removeSubscriptionWithProfessionalLicense(data) {
    return this.httpService.post<any>(`api/payment/remove-subscription-professional-license`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getFamilyPlanList() {
    return this.httpService.get<any>(`api/payment/family-subscription-list`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getPremiumPlanList() {
    return this.httpService.get<any>(`api/payment/premium-subscription-list`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getMyCurrentSubscription(isLoader = true) {
    return this.httpService.get<any>(`api/payment/current-subscription`, null, isLoader ? loaderTypes.mainAnimation : loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  checkPromocode(code, productid) {
    const data = {
      coupons: code,
      productid: productid,
    };
    return this.httpService.post<any>(`api/payment/check-promocode`, data, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createSubscriptionImmediatePayment(data) {
    return this.httpService.post<any>(`api/payment/create-subscription-immediate-payment`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createPaymentSetupIntent(data) {
    return this.httpService.post<any>(`api/payment/create-payment-setup-intent`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  createSubscriptionNormal(data) {
    return this.httpService.post<any>(`api/payment/create-subscription`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserPermissionsRecivedAllAccedtedWithActiveDistributionTriger() {
    return this.httpService.get<any>(`api/permission/active-distributions`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getUserPermissionsRecivedAllAccedted() {
    return this.httpService.get<any>(`api/permission/permission-received`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getUserPermissions(params) {
    return this.httpService.get<any>(`api/permission/permissions-request-relations`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getUserPermissionsNEWAPI() {
    return this.httpService.get<any>(`api/permission/permissions-request-relations`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getPermissionsGrantRelationsFolder(id) {
    return this.httpService.get<any>(`api/permission/permissions-grant-relations-folder/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserChecklistShare(id) {
    return this.httpService.get<any>(`api/checklist/template-share/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  geGranttUserPermissionsNEWAPI() {
    return this.httpService.get<any>(`api/permission/permissions-grant-relations`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  addUserPermission(params) {
    return this.httpService.post<any>(`api/permission/add-user-permission`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateUserPermission(params) {
    return this.httpService.post<any>(`api/permission/update-user-permission-request`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  DeletechecklistPermission(params) {
    return this.httpService.post<any>(`api/checklist/template-share-delete`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  DeletePermissionGrantDistributorAdmin(params) {
    return this.httpService.post<any>(`api/permission/permission-grant-delete`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  addUserPermissionRequest(params) {
    return this.httpService.post<any>(`api/permission/add-user-permission-request`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  addUserForSharedChecklist(params) {
    return this.httpService.post<any>(`api/checklist/template-share`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  adminAskAccessWithFolder(params) {
    return this.httpService.post<any>(`api/permission/permission-grant`, params).pipe(
      map((response) => {
        if (response.status == 200 || response.status == 201) {
          if (response?.data?.limit_exceeded) {
            let data: HttpErrorResponse = new HttpErrorResponse({ error: 'Data incorrect', status: 400 });

            const modalRef3 = this.dialog.open(PaymentErrorScreenComponent, {
              panelClass: 'full-window-dialog-2',
              autoFocus: false,
              disableClose: true,
              data: response?.data,
            });

            return this.handleAuthError(data);
          } else {
            return response.data;
          }
        } else {
          return response;
        }
      })
    );
  }

  deletePermissionRequest(params) {
    return this.httpService.post<any>(`api/permission/delete-permission-request`, params).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getPermissions() {
    return this.httpService.get<any>(`api/permission/permission`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  createUpdatepermissionRequest(body) {
    return this.httpService.post<any>(`api/permission/permission-request`, body).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  sendOTPCancelFolder(id, vault_id = null) {
    let url = `api/permission/cancel-distribution-otp/${id}`;
    if (vault_id != null) {
      url = url + `?vault_id=${vault_id}`;
    }
    return this.httpService.get<any>(url).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  sendOTPAccessFolder(id, vault_id = null) {
    let url = `api/permission/trigger-distribution-otp/${id}`;
    if (vault_id != null) {
      url = url + `?vault_id=${vault_id}`;
    }

    return this.httpService.get<any>(url).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  CancelvarifyOPTwiwhtId(data) {
    return this.httpService.post<any>(`api/permission/cancel-distribution-verify-otp`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  varifyOPTwiwhtId(data) {
    return this.httpService.post<any>(`api/permission/trigger-distribution-verify-otp`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  gaveaccessForDistributor(data) {
    return this.httpService.post<any>(`api/permission/trigger-distribution`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  removedaccessForDistributor(data) {
    return this.httpService.post<any>(`api/permission/cancel-distribution`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getSubscriptionProfessionalFromFamilyLicense() {
    return this.httpService.get<any>(`api/payment/subscription-professional-from-family-license`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateCouponWithFamilyLicense(data) {
    return this.httpService.patch<any>(`api/payment/update-coupon-family-license`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getPaymentMethods() {
    return this.httpService.get<any>(`api/payment/payment-methods`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  makePrimaryPaymentMethod(body) {
    return this.httpService.patch<any>(`api/payment/payment-method-primary`, body, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deletePaymentMethod(paymentMethodId) {
    return this.httpService.delete<any>(`api/payment/payment-method/${paymentMethodId}`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  /**
   * manage errors
   * @param err
   * @returns {any}
   */
  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    throw err;
  }
}
